var React = require('react');

function IconHome (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z","transform":"translate(-2 -3)","style":{"fill":"#9e9e9e"}}));
}

IconHome.defaultProps = {"width":"20","height":"17"};

module.exports = IconHome;

IconHome.default = IconHome;
